<!-- Begin page content -->
<main class="flex-shrink-0">
  <div class="container">

    <!-- News section -->
    <section id="news" [ngClass]="{block: newsList, none: noNewsList}">
      <div *ngIf="newsList?.length > 0" class="news-content">
        <div class="container">
          <div class="row mt-3">
            <div class="col-lg-3">
              <span class="title">Новости</span>
            </div>
            <div class="col">
              <div class="line"></div>
            </div>
          </div>

          <div class="row mt-4">
            <div class="col-lg-3" *ngFor="let item of newsList">
              <div class="card mb-3" (click)="redirectNewsPage(item)">
                <!-- <img src="../../assets/img/55.png" class="card-img-top" alt="..."> -->
                <img src="{{item.image}}" class="card-img-top" alt="...">
                <div class="card-body">
                  <!-- <h5 class="card-title">Card title</h5> -->
                  <p class="card-text"><small class="text-muted">Опубликовано {{item.published | date: 'dd.MM.yyyy'}}</small></p>
                  <p class="card-text">{{item.title}}</p>
                </div>
              </div>
            </div>
          </div>
<!--          <div class="row">-->
<!--            <div class="col-lg-12 text-center">-->
<!--              <nav aria-label="Page navigation example">-->
<!--                <ul class="pagination justify-content-center">-->
<!--                  <li class="page-item disabled">-->
<!--                    <a class="page-link" href="#" tabindex="-1" aria-disabled="true">Пред</a>-->
<!--                  </li>-->
<!--                  <li class="page-item"><a class="page-link" href="#">1</a></li>-->
<!--                  <li class="page-item"><a class="page-link" href="#">2</a></li>-->
<!--                  <li class="page-item"><a class="page-link" href="#">3</a></li>-->
<!--                  <li class="page-item">-->
<!--                    <a class="page-link" href="#">След</a>-->
<!--                  </li>-->
<!--                </ul>-->
<!--              </nav>-->
<!--            </div>-->
<!--          </div>-->
        </div>
      </div>
    </section>

    <section id="world-news" [ngClass]="{block: worldNewsList, none: noWorldNewsList}">
      <div *ngIf="worldNewsList?.length > 0" class="news-content">
        <div class="container">
          <div class="row mt-3">
            <div class="col-lg-3">
              <span class="title">МЕЖДУНАРОДНЫЕ НОВОСТИ</span>
            </div>
            <div class="col">
              <div class="worldLine"></div>
            </div>
          </div>

          <div class="row mt-4">
            <div class="col-lg-3" *ngFor="let item of worldNewsList">
              <div class="card mb-3" (click)="redirectNewsPage(item.id, item.type)">
                <!-- <img src="../../assets/img/55.png" class="card-img-top" alt="..."> -->
                <img src="{{item.image}}" class="card-img-top" alt="...">
                <div class="card-body">
                  <!-- <h5 class="card-title">Card title</h5> -->
                  <p class="card-text"><small class="text-muted">Опубликовано {{item.published | date: 'dd.MM.yyyy'}}</small></p>
                  <p class="card-text">{{item.title}}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12 text-center">
              <nav aria-label="Page navigation example">
                <ul class="pagination justify-content-center">
                  <li class="page-item disabled">
                    <a class="page-link" href="#" tabindex="-1" aria-disabled="true">Пред</a>
                  </li>
                  <li class="page-item"><a class="page-link" href="#">1</a></li>
                  <li class="page-item"><a class="page-link" href="#">2</a></li>
                  <li class="page-item"><a class="page-link" href="#">3</a></li>
                  <li class="page-item">
                    <a class="page-link" href="#">След</a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </section>


    <section id="no-results" [ngClass]="{block: noNewsList && noWorldNewsList, none: newsList || worldNewsList}">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="no-results-found-block text-center">
              <img src="../../assets/img/main/error.png" alt="" width="200">
              <div class="mt-2">
                <h2 style="font-weight: 600;">Результатов не найдено</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</main>
